export default {
  default: () => import("E:/github/khalej/layouts/default.vue")
}